<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperSystemParameters',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'systemParameterModule',
    };
  },
};
</script>
